/**
 * Single-player HighLow game-domain types.
 * Ported from packages/amghighlow_v2/lib/core/constants/game_constants.dart
 */

export type GamePhase =
  | 'idle'
  | 'initializing'
  | 'betting'
  | 'bettingClosed'
  | 'cardReveal'
  | 'showResult'
  | 'newRound'
  | 'shuffling'
  | 'error';

export type BetType = 'high' | 'low';

export const BET_ITEM_ID: Record<BetType, number> = {
  high: 301,
  low: 302,
};

/** placeBetClick.betID → BetType. 1=High, 2=Low (matches game_bloc.dart). */
export function betTypeFromClickId(id: number): BetType | null {
  if (id === 1) return 'high';
  if (id === 2) return 'low';
  return null;
}

export function betTypeFromItemId(id: number): BetType | null {
  if (id === 301) return 'high';
  if (id === 302) return 'low';
  return null;
}

export type GameResult = 'high' | 'low' | 'tie';

export interface GameConfig {
  minBet: number;
  maxBet: number;
  chipValues: readonly number[];
}

/** Per-round summary after the result card is revealed. */
export interface GameRound {
  round: number; // 1..3 within the current cycle
  firstCard: number; // raw 1..52 value of the start card
  secondCard: number; // raw 1..52 value of the result card
  result: GameResult;
  totalWinLose: number;
  totalBet: number;
  positiveWinAmount: number;
  hasPositiveWin: boolean;
}
